import React, { useEffect } from "react";

import { useSearchPageContext } from "../context";
import { LadiesResults } from "./LadiesResults";
import { MobileSearchFilters } from "./MobileSearchFilters";
import { SearchFilters } from "./SearchFilters";

export const SearchPageMainContent: React.FC = () => {
  const { data } = useSearchPageContext();

  useEffect(() => {
    document.body.scrollTop = 0;
  }, [data]);

  return (
    <div>
      <MobileSearchFilters />
      <div className="flex p-4 pt-0 gap-x-4">
        <SearchFilters className="hidden md:flex" />
        <LadiesResults />
      </div>
    </div>
  );
};
